import { cn } from '@/lib/utils';

export function OutputDisclaimer({ className }: { className?: string }) {
  return (
    <p className={cn('text-xs text-gray-400', className)}>
      Crimson can make mistakes. Verify the outputs.
    </p>
  );
}
